import {Component} from "react";
import {connect} from "react-redux";
import {Box, Button, Stack, Typography} from "@mui/material";
import {AppTitle} from "../components/components";
import sample_card_black from "../../../asset/img/credit_card_black.png";
import {StyledSlider1} from "../components/StyledComponents";
import {mapViewerConfigurationsToProps} from "../../../redux_reducers/utils";
import {updateConfigurations} from "../../../redux_actions/morpheus.setting.action";
import {updateLastMapCount} from "../../../redux_actions/gamma.state.action";

class DisplayCalibration extends Component {

	updateZoomRatio = (zoomRatio) =>
		this.props.dispatch(updateConfigurations({
			...this.props.viewer_configurations,
			zoomRatio,
		}));

	apply = () => this.props.dispatch(updateLastMapCount());


	render() {
		let zoomRatio = this.props.viewer_configurations.zoomRatio || 1.0;
		return <Stack direction={"column"} spacing={2} padding={1}>
			<AppTitle title={"Display Calibration"}/>
			<StyledSlider1 min={1} max={2} step={0.01}
			               defaultValue={zoomRatio}
			               onChange={(event, ratio) => this.updateZoomRatio(ratio)}
			               valueLabelDisplay="auto"/>
			<Stack direction={"row"} justifyContent={"space-between"}>
				<Box width={180}>
					<img src={sample_card_black} width={180}
					     height={210 * zoomRatio} alt={"card"}/>
				</Box>
				<Stack direction={"column"} marginY={5}>
					<Typography color={"whitesmoke"}>Scale Ratio</Typography>
					<Typography color={"whitesmoke"}>{zoomRatio}</Typography>
					<Button variant={"contained"} color={"primary"} sx={{margin: 1}} onClick={this.apply}>Apply</Button>
				</Stack>
			</Stack>
		</Stack>
	}
}

export default connect(mapViewerConfigurationsToProps)(DisplayCalibration);
